// extracted by mini-css-extract-plugin
export default {"empty-post-container":"posts_empty-post-container__RDITv"};